import styled from 'styled-components';

export const Layer = styled.div`
  text-align: center;

  .lds-roller {
    display: inline-block;
    position: relative;
    width: 21px;
    height: 21px;
    zoom: 120%;
    margin-top: 10px;
  }
  .lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 8px 8px;
  }
  .lds-roller div:after {
    content: ' ';
    display: block;
    position: absolute;
    border-radius: 50%;
    background: #cef;
    margin: -1px 0 0 -1px;
  }
  .lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
  }
  .lds-roller div:nth-child(1):after {
    top: 12.5px;
    left: 12.5px;
    width: 0.5px;
    height: 0.5px;
    background-color: #FFF;
  }
  .lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
  }
  .lds-roller div:nth-child(2):after {
    top: 13.5px;
    left: 11.2px;
    width: 1px;
    height: 1px;
    background-color: #FFF;
  }
  .lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
  }
  .lds-roller div:nth-child(3):after {
    top: 14.2px;
    left: 9.7px;
    background-color: #FFF;
    width: 1.5px;
    height: 1.5px;
  }
  .lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
  }
  .lds-roller div:nth-child(4):after {
    top: 14.5px;
    left: 8px;
    background-color: #FFF;
    width: 2px;
    height: 2px;
  }
  .lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
  }
  .lds-roller div:nth-child(5):after {
    top: 14.2px;
    left: 6.2px;
    width: 2px;
    height: 2px;
    background-color: #FFF;
  }
  .lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
  }
  .lds-roller div:nth-child(6):after {
    top: 14px;
    left: 4px;
    width: 2.5px;
    height: 2.5px;
    background-color: #FFF;
  }
  .lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
  }
  .lds-roller div:nth-child(7):after {
    top: 12px;
    left: 2px;
    width: 3px;
    height: 3px;
    background-color: #FFF;
  }
  .lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
  }
  .lds-roller div:nth-child(8):after {
    background-color: #FFF;
    width: 4px;
    height: 4px;
    top: 8px;
  }
  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Container = styled.div``;















